export default __webpack_public_path__ + "static/media/GuestUser.e27af672.svg";